<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
      (openSideNav)="sidenav.toggle()"></app-header>
    <div class="sggs-dashboard-content">
      <div class="small-carousel carousel-wrapper" style="background-color: #ffffff !important;"
        [class.is-mobile]="isHandsetPortrait">
        <div class="title-container">
          <div class="title-banner-wrapper-new {{bannerClass}}">

            <div class="backToArticlePage">
              <a class="backToArticlePageLink" (click)="goBackToArticlePage()" style="cursor: pointer;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 18 18">
                    <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"/> 
                  </svg>
                  Back to Articles
              </a>
            </div>

            <div class="articleDetailsTitleBanner">
              <h1 class="title-banner-text">Article Title</h1>
              <h3 class="title-banner-subtext">Article Subtitle</h3>
              <div class="authorNameSect">
                <div class="autherNameWithImg" *ngFor="let Author of repeatArticalCard.slice(0, 4);" (click)="gotoTeamsPage(Author)">
                  <span class="authorName">Author Name</span>
                  <img class="authorImage" src="https://devtggspstorage.blob.core.windows.net/sikhriimages/TeamUserImages/Harsohena%20Kaur_150x150.webp" alt="{{Author}} Image">
                </div>
              </div>
              <div class="articlePublishDate">
                <span class="articleDateText">Publish Date</span>
              </div>
              <div class="baniCompositionSec">
                <ng-container *ngFor="let article of repeatArticalCard.slice(0, 3);">
                  <span class="baniCompositionText">Bani Composition {{activeLanguageTranslations.baniComposition}}</span>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
  <!-- ************************************************** Detail Section ***************************************************************************************************   -->

      <section class="articleDetailsSection">
        <div class="articleDetailsWrapper">
         <h2>The Guru Granth Sahib Project is a global initiative dedicated to making the teachings of the Guru Granth Sahib accessible to English and Punjabi speakers worldwide.</h2>
         <ng-container *ngFor="let article of repeatArticalCard.slice(0, 9);">
           <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
         </ng-container>
        </div>
      </section>

      <div class="my-5">
        <app-newsletter></app-newsletter>
      </div>
      <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>